import type { MouseEvent } from 'react';

import ArrowBack from '../../../../../public/assets/icons/arrowBack.svg';
import { MessagesSwitchButton, MessagesSwitchContainer } from './styles';

export interface MessagesSwitchProps {
	className?: string;
	onChange?(value: number): void;
	value: number;
	total: number;
	disabled?: boolean;
}

export const MessagesSwitch = ({
	onChange,
	value,
	total,
	disabled,
	...props
}: MessagesSwitchProps) => {
	const onClick = (event: MouseEvent<HTMLButtonElement>) => {
		const { name } = event.currentTarget;
		let newValue = value;

		if (name === 'right') {
			newValue++;
		} else {
			newValue--;
		}

		onChange?.(newValue);
	};

	return (
		<MessagesSwitchContainer {...props}>
			<MessagesSwitchButton
				name="left"
				onClick={onClick}
				disabled={disabled || value <= 0}
			>
				<ArrowBack />
			</MessagesSwitchButton>
			<span>
				{value + 1} / {total}
			</span>
			<MessagesSwitchButton
				name="right"
				onClick={onClick}
				disabled={disabled || value >= total - 1}
			>
				<ArrowBack />
			</MessagesSwitchButton>
		</MessagesSwitchContainer>
	);
};
